/* eslint-disable */
import { ISupportDesk, ISupportData } from 'src/interfaces';
import http from './http';
import axios, { AxiosError } from 'axios';

class SupportDeskService {
  static getSupportTickets(params: any): Promise<{ items: ISupportDesk[]; meta: { totalItems: number } }> {
    let stringParams = '';
    for (const key in params) {
      if (stringParams === '') {
        stringParams += `${key}=${params[key]}`;
      } else {
        stringParams += `&${key}=${params[key]}`;
      }
    }
    return http
      .get(`support-ticket?${stringParams}`, {
        headers: { companyId: params.companyId },
      })
      .then(resp => resp.data);
  }

  static getSupportTicketsReply(params: any): Promise<ISupportData> {
    return http
      .get(`/support-ticket/support-ticket-reply/${params.ticketId}`, {
        headers: { companyId: params.companyId },
      })
      .then(resp => resp.data);
  }

  static addSupporTicketReply(supportTicketId: string, formData: FormData) {
    return http
      .post(`/support-ticket/reply/${supportTicketId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static updateSupportTicketStatus(ticketId: string, status: string) {
    return http
      .patch(`/support-ticket/support-ticket-status-crm/${ticketId}?status=${status}`)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static updateSupportTicket(ticketId: string, updateData: any) {
    return http
      .patch(`/support-ticket/crm-support-tickets/support-ticket-status/${ticketId}`, updateData, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static reopenTicket(supportTicketId: string, ticket: any) {
    return http
      .post(`/support-ticket/reply-and-open/${supportTicketId}`, ticket, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static getUsersSearchNewSupport(search: string) {
    return http.get(`/users/supportAdminUsersActive?email=${search}`);
  }

  static assignUser(values: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      http
        .post('/support-ticket/assign', values)
        .then(() => {
          resolve();
        })
        .catch((error: AxiosError) => {
          if (error.response && error.response.data && error.response.data.message) {
            reject(new Error(error.response.data.message));
          }
        });
    });
  }
}
export default SupportDeskService;
